import { CATEGORY_FILTER_SLUG } from "@/composables/marketplace/useMarketplaceSearch";
import { useRememberedCategory } from "@/composables/categories/useRememberedCategory";
import { usePendingSearchQuery } from "@/composables/homepage/usePendingSearchQuery";
import { createMarketplaceLink } from "@/router";
import { fetchCategoryByUrl } from "@/services/collection/categories";
import { computedAsync } from "@vueuse/core";
import { useRoute, useRouter } from "vue-router";
import { DefaultPerPage, Sort } from "@/services/marketplace/item";

export function useSelectedCategory() {
  const route = useRoute();

  const categorySlug = computed(() => {
    const value = route.query[CATEGORY_FILTER_SLUG];
    return typeof value === "string" && value !== "" ? value : undefined;
  });

  const isCategorySelected = computed(() => categorySlug.value !== undefined);

  const selectedCategory = computedAsync(async () => {
    if (categorySlug.value === undefined) return undefined;
    return fetchCategoryByUrl(categorySlug.value);
  });

  const router = useRouter();
  const { rememberCategoryId } = useRememberedCategory();
  const { consumePendingQuery } = usePendingSearchQuery();

  watch(selectedCategory, (category) => {
    if (!category) return;
    rememberCategoryId(category.id);
    const pendingQuery = consumePendingQuery();
    if (pendingQuery) {
      router.replace(
        createMarketplaceLink({
          query: pendingQuery,
          page: 0,
          perPage: DefaultPerPage,
          sort: Sort.Relevance,
          category: category.url,
        })
      );
    }
  });

  return {
    categorySlug,
    isCategorySelected,
    selectedCategory,
  };
}
